module.exports = __webpack_public_path__ + "static/img/copy_btn_bg.fca26eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/invitation/copy_btn_bg.png
// module id = aqCW
// module chunks = 1